module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-intl/gatsby-browser.js'),
      options: {"plugins":[],"path":"/home/gustavom/fabacus/redemption-campaign-nobodyschild-nbc/src/intl","languages":["en","fr"],"defaultLanguage":"en","redirect":false},
    }]
